import { inject, Injectable } from '@angular/core';
import { BaseApiService } from '../base-api.service';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface GetCategoryRequest {}
export interface CategoryData {
  type_id: string;
  type_name: string;
}
type GetCategoryResponse = {
  RequestURL: 'getCatType';
  catTypeCount: number;
  catTypeList: { catType: CategoryData }[];
};
@Injectable({
  providedIn: 'root',
})
export class GetCategoryService {
  private baseApiService = inject(BaseApiService);

  getCategoryApi(url: string, req: null) {
    return this.baseApiService.basePost<null, GetCategoryResponse>(url, req);
  }
}
